import "../../../styles/website/Footer.css";
import flowerFooter from "../../../assets/website/flower-footer.svg";
import WhiteLogo from "../../../assets/website/white-logo-full.svg";

/* =========================================================
   آیکون‌ها
   ========================================================= */

const PinIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 21C12 21 19 14.5 19 9.5C19 5.36 15.64 2 12 2C8.36 2 5 5.36 5 9.5C5 14.5 12 21 12 21Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="9.5" r="2.3" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
    <path
      d="M4.5 5C4.5 4 5.4 3 6.4 3H8.7L10.2 7L8.2 8.6C9.2 11 11 12.8 13.4 13.8L15 11.8L19 13.3V15.6C19 16.6 18 17.5 17 17.5C10.4 17.5 4.5 11.6 4.5 5Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MailIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M3 6.5L12 13L21 6.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <rect
      x="3"
      y="3"
      width="18"
      height="18"
      rx="5"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="17.2" cy="6.8" r="1" fill="currentColor" />
  </svg>
);

const TelegramIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M21 3L3 10.5L10 13L12.5 20L15 15L21 3Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M10 13L21 3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

const WhatsappIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M12 3C7 3 3 7 3 12C3 13.6 3.4 15.1 4.2 16.4L3 21L7.7 19.8C9 20.6 10.5 21 12 21C17 21 21 17 21 12C21 7 17 3 12 3Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 8.5C8.5 8.5 8 10.5 9.5 12C11 13.5 13 13 13 13"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

/* =========================================================
   داده‌ها
   ========================================================= */

const FOOTER_LINKS = [
  { label: "ثبت‌نام فروشگاه", href: "/panel/login" },
  { label: "قوانین و مقررات", href: "/rules" },
  { label: "فروشگاه‌ها", href: "/shops" },
  { label: "تعرفه‌ها", href: "/pricing" },
  { label: "تماس با ما", href: "/contact" },
];

const SOCIAL_LINKS = [
  {
    label: "اینستاگرام",
    href: "https://instagram.com/dokana.ir",
    icon: <InstagramIcon />,
  },
  {
    label: "تلگرام",
    href: "https://t.me/+989105109255",
    icon: <TelegramIcon />,
  },
  {
    label: "واتساپ",
    href: "https://wa.me/989105109255",
    icon: <WhatsappIcon />,
  },
];

/* =========================================================
   کامپوننت
   ========================================================= */

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="wrap footer-grid">
        <div className="footer-col footer-brand">
          <div className="logo">
            <span className="logo-mark">
              <img className="logo-dokana" src={WhiteLogo} alt=""></img>
            </span>{" "}
            دُکانا
          </div>
          <p>
            بانک جامع فروشگاه‌های آنلاین ایران؛ فروشگاهت رو در چند دقیقه بساز.
          </p>
        </div>

        <div className="footer-col">
          <h4>لینک‌های مهم</h4>
          <ul className="footer-links">
            {FOOTER_LINKS.map((link) => (
              <li key={link.label}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4>اطلاعات تماس</h4>
          <ul className="footer-contact-list">
            <li>
              <PinIcon size={15} />
              یزد - خیابان مطهری - مرکز فناوری رشد اقبال - واحد E166
            </li>
            <li>
              <PhoneIcon />
              ۰۳۵۳۸۲۷۲۶۶۷-۶۶
            </li>
            <li>
              <MailIcon />
              info@dokana.ir
            </li>
          </ul>
        </div>

        <div className="footer-col footer-col-modified">
          <h4>شبکه‌های اجتماعی</h4>
          <div className="footer-social">
            {SOCIAL_LINKS.map((social) => (
              <a
                key={social.label}
                href={social.href}
                aria-label={social.label}
              >
                {social.icon}
              </a>
            ))}
          </div>
          <div className="ft-badges">
            <div>
              <a
                referrerPolicy="origin"
                target="_blank"
                href="https://trustseal.enamad.ir/?id=742600&Code=IE2jOyE5Iwns1RMZya3U7BrIRMCCYtUs"
              >
                <img
                  referrerPolicy="origin"
                  src="https://trustseal.enamad.ir/logo.aspx?id=742600&Code=IE2jOyE5Iwns1RMZya3U7BrIRMCCYtUs"
                  alt=""
                  style={{ cursor: "pointer" }}
                  code="IE2jOyE5Iwns1RMZya3U7BrIRMCCYtUs"
                />
              </a>
            </div>

            <div className="ft-badge-item">
              <a
                href="https://bitpay.ir/certificate-769112-dokana.ir"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://bitpay.ir/theme/public/images/trusted-logo.svg"
                  alt="بیت‌پی"
                  style={{ cursor: "pointer" }}
                />
              </a>
            </div>

            <div className="ft-badge-item">
              {/* دیوایدر سوم - محتوا بعداً اضافه می‌شود */}
            </div>
          </div>
          <img className="image-flower-footer" src={flowerFooter} alt="" />
        </div>
      </div>

      <div className="wrap footer-bottom">
        <div>تمامی حقوق این وب‌سایت متعلق به دُکانا است.</div>
        <div>
          ساخته شده در{" "}
          <a
            href="https://bavarsazan.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            باورسازان هوشمند
          </a>
        </div>
      </div>
    </footer>
  );
}
